import React from 'react';

export default function Footer() {
  const getYear = (): number => {
    return new Date().getFullYear();
  };

  return (
    <footer className="block bg-dark_willow pl-8 md:pr-8 md:pt-8 md:pb-8 md:pl-8 pr-6 pt-8 pb-8 pl-6 md:min-h-138px">
      <div className="mb-3">
        <img
          alt="logo-idn"
          src="/assets/images/logo_idn.svg"
          className="h-auto"
          style={{ width: '35px', padding: '2px 0' }}
        />
      </div>
      <p className="mb-1 block text-size12 leading-19px text-white">
        Copyright &copy; {getYear()} IDN, All right reserved
      </p>
      <p className="block text-size12 text-white leading-19px max-w-250px md:max-w-full">
        “Democratize information and bring positive impacts to society”
      </p>
    </footer>
  );
}
